var jade = require("/home/circleci/rentapplication-frontend/node_modules/jade/lib/runtime.js");

module.exports = function template(locals) {
var buf = [];
var jade_mixins = {};
var jade_interp;

buf.push("<div class=\"global_wrapper newform1 create-form\"><navbar></navbar><div ng-if=\"display_subnav\" class=\"row top\"><!-- <h2>New Form</h2>--><ul><li ng-class=\"{active: steps_mapping.indexOf(current_state) &gt;= 0, ready: steps_mapping.indexOf(current_state) &gt; 0}\" class=\"form-step-1\"><div class=\"circle-block\"><div class=\"circle\"><p>1</p></div></div><h3>Select Reports</h3></li><li ng-class=\"{ready: steps_mapping.indexOf(current_state) &gt; 0}\" class=\"line line-step-1\"></li><li ng-class=\"{active: steps_mapping.indexOf(current_state) &gt;= 1, ready: steps_mapping.indexOf(current_state) &gt; 1}\" class=\"form-step-2\"><div class=\"circle-block\"><div class=\"circle\"><p>2</p></div></div><h3>Create Link</h3></li></ul></div><div ui-view=\"\"></div></div>");;return buf.join("");
}


//////////////////
// WEBPACK FOOTER
// ./components/forms/forms.jade
// module id = 1022
// module chunks = 0